<template>
    <div class="card pb-5" v-if="condition">
        <div class="title text-center" style="margin-top: 80px;">
            <h2>{{text}}</h2>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ConditionalText',
        props: ["condition", "text"],
        data: function () {
            return {

            };
        },
        watch: {
        },
        methods: {
        },
        mounted: function () {
            //console.log("Conditional text loaded", this.condition, this.text);
        },
    }
</script>